import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import BreadcrumbPageHeader from '@/layouts/BreadcrumbPageHeader';
import { PageLoading } from '@/layouts/PageLoading';
import { RoleType, useUser } from '@/services/authentication/hooks/user';
import { PageTitle } from '@/utils/Title';
import { FunctionComponent, Suspense, useEffect } from 'react';
import { useNavigate } from 'react-router';
import EditMspWizard from './EditMspWizard';

const EditMspPageContent: FunctionComponent = () => {
  const { role } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (role.type !== RoleType.Admin) {
      navigate('-1');
    }
  }, []);

  const breadcrumbs: NavPage[] = [
    {
      name: 'MSPs',
      to: '/msps/manageMsps'
    }
  ];

  return (
    <>
      <BreadcrumbPageHeader breadcrumbs={breadcrumbs}>
        <div className="flex justify-between gap-5 items-center font-bold">
          <h3 className="text-3xl">Edit MSP</h3>
        </div>
      </BreadcrumbPageHeader>
      <div className="flex-1 overflow-y-auto">
        <EditMspWizard />
      </div>
    </>
  );
};

const EditMspPage: FunctionComponent = () => {
  return (
    <>
      <PageTitle>Edit MSP</PageTitle>
      <Suspense fallback={<PageLoading />}>
        <EditMspPageContent />
      </Suspense>
    </>
  );
};

export default EditMspPage;
